import owd from 'owd/owd';

export default class Form extends owd.Component {
	init() {
		this.action = this.$element.data('form');
		this.isMultiPart = this.$element.is('[enctype="multipart/form-data"]');
		this.initSteps();
		this.bind();
	}

	bind() {
		this.on('focus', 'input, select, textarea', (e) => {
			$(e.target).removeClass('error');
			$(e.target).parents('.custom-select').removeClass('error');
		});

		this.on('click', '.custom-checkbox', (e) => {
			$(e.target).find('input[type="checkbox"]').removeClass('error');
		});

		this.on('click', '[data-form-next]', (e) => {
			e.preventDefault();
			this.nextStep();
		});

		this.on('open', (e) => {
			if (!this.$element.is('[data-form-no-reset]')) {
				this.$element.find('input[type=text],input[type=tel],input[type=number],select,input[type=email],textarea').val('').trigger('change');
			}
			this.defaultStep();
		});

		this.on('submit', (e) => {
			e.preventDefault();

			if (this.isLastStep()) {
				this.enableLoading();

				this.$element.find('.ajax-message').hide(0);
				this.$element.find('input, select, textarea, select, .custom-select').removeClass('error').blur();

				this.submit()
				.always(() => {
					this.disableLoading();
				});
			} else {
				this.nextStep();
			}
		});
	}

	submit() {
		const ajaxParams = {
			url: ajaxurl + '?action=form_' + this.action,
			type: 'post',
			dataType: 'json',
			data: this.$element.serialize()
		};

		if (this.isMultiPart) {
			ajaxParams.data = new FormData(this.$element[0]);
			ajaxParams.processData = false;
			ajaxParams.contentType = false;
		}

		if (window.ga !== undefined) {
			try {
				ga('send', 'event', 'form', 'submit', this.$element.data('form'));
			} catch (e) {}
		}

		return $.ajax(ajaxParams).done((response) => {
			if (response.result) {
				if (!this.$element.is('[data-form-no-reset]')) {
					this.$element.find('input[type=file],input[type=text],input[type=tel],input[type=number],select,input[type=email],textarea')
						.removeClass('error')
						.val('')
						.trigger('change');

					this.$element.find('input[type="checkbox"]').prop('checked', false);
				}

				this.successStep();
				this.$element.find('.ajax-message.ok').fadeIn(400);
				this.$element.trigger('success', response);
			} else {
				this.$element.find('.ajax-message.error').fadeIn(400);

				for (let i in response.errors) {
					this.$element.find('input[name="' + i + '"],input[name^="' + i + '["],select[name="' + i + '"],textarea[name="' + i + '"]').addClass('error').trigger('error');
					this.$element.find('select[name="' + i + '"]').parents('.custom-select').addClass('error').trigger('error');
				}

				this.$element.trigger('error', response.errors);
				this.errorStep();
			}
		});
	}

	enableLoading() {
		this.$element.addClass('loading');
	}

	disableLoading() {
		this.$element.removeClass('loading');
	}

	initSteps() {
		if (this.$element.find('.form-part').length) {
			this.$steps = this.$element.find('.form-part:not(.success)');
			this.$defaultStep = this.$element.find('.form-part.default');
			this.$successStep = this.$element.find('.form-part.success');
			this.stepsCount = this.$steps.length;
			this.currentStep = 0;
			this.stepsEnabled = true;
		} else {
			this.stepsEnabled = false;
		}
	}

	defaultStep() {
		if (this.stepsEnabled) {
			this.$steps.filter('.is-visible').removeClass('is-visible');
			this.$successStep.removeClass('is-visible');
			this.$defaultStep.addClass('is-visible');
			setTimeout(() => {
				this.$defaultStep.find('input').eq(0).focus();
			}, 100);
		}
	}

	successStep() {
		if (this.stepsEnabled) {
			this.$steps.filter('.is-visible').removeClass('is-visible');
			this.$successStep.addClass('is-visible');
		}
	}

	isLastStep() {
		if (this.stepsEnabled) {
			return this.currentStep + 1 >= this.stepsCount;
		}

		return true;
	}

	errorStep() {
		if (this.stepsEnabled) {
			let $error = this.$steps.find('.error').parents('.form-part');

			if (!this.$steps.eq(this.currentStep).is($error)) {
				this.$steps.filter('.is-visible').removeClass('is-visible');
				$error.addClass('is-visible');
				this.$steps.filter('.is-visible').find('input').eq(0).focus();
			}
		}
	}

	nextStep() {
		if (this.stepsEnabled && !this.isLastStep()) {
			this.currentStep++;
			this.$steps.filter('.is-visible').removeClass('is-visible');
			this.$steps.eq(this.currentStep).addClass('is-visible');
			this.$steps.filter('.is-visible').find('input').eq(0).focus();
		}
	}
}

owd.registerComponent('form', {
	component: Form
});
